import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/data',
    name: 'data',
    component: () => import('../views/propriedades/Data.vue')
  },
  {
    path: '/computed',
    name: 'computed',
    component: () => import('../views/propriedades/Computed.vue')
  },
  {
    path: '/methods',
    name: 'methods',
    component: () => import('../views/propriedades/Methods.vue')
  },

  {
    path: '/watch',
    name: 'watch',
    component: () => import('../views/propriedades/Watch.vue')
  },
  {
    path: '/exercicio',
    name: 'exercicio',
    component: () => import('../views/propriedades/Exercicio.vue')
  },



  {
    path: '/beforeCreate',
    name: 'beforeCreate',
    component: () => import('../views/hooks/BeforeCreate.vue')
  },

  {
    path: '/component',
    name: 'component',
    component: () => import('../views/hooks/Component.vue')
  },

  {
    path: '/transition',
    name: 'transition',
    component: () => import('../views/hooks/Transition.vue')
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
